import { Box, createTheme, Typography } from '@mui/material'
import { Inbox } from '@mui/icons-material'
import BrandingService from './BrandingService'
import { red } from '@mui/material/colors'

export default createTheme({
  shape: { borderRadius: 8 }, // Determines how round / sharp element corners are
  typography: { fontFamily: ['Montserrat'], fontSize: 13 }, // Determines the default font options
  palette: BrandingService.current.palette,
  components: {
    MuiTextField: { defaultProps: { variant: 'outlined', size: 'small', fullWidth: true } },
    // Issue with dialog contents being cut off. Global override prevents this issue until it is resolved internally.
    MuiDialogContent: { styleOverrides: { root: { paddingTop: `10px !important` } } },
    MuiButton: {
      defaultProps: { variant: 'contained', fullWidth: true },
      styleOverrides: { root: { textTransform: 'none' } }
    },
    MuiDataGrid: {
      defaultProps: {
        columnHeaderHeight: 40,
        disableSelectionOnClick: true,
        components: { NoRowsOverlay: CustomNoRowsOverlay },
        slots: { noRowsOverlay: CustomNoRowsOverlay },
        sx: {
          boxShadow: 2,
          '& .MuiDataGrid-columnSeparator': { visibility: 'hidden' },
          '& .MuiDataGrid-columnHeader': {
            bgcolor: 'primary.dark',
            color: 'primary.contrastText',
            '.MuiCheckbox-root': { color: 'primary.contrastText' },
          },
          '& .MuiDataGrid-columnHeaders': { '.MuiDataGrid-scrollbarFiller': { bgcolor: 'primary.dark' } },
          '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' },
          '& .MuiDataGrid-virtualScrollerRenderZone': {
            // '> *': { borderTop: 1, borderColor: 'info.dark' },
            '> :first-of-type': { border: 0 },
            '> :nth-of-type(2n)': { bgcolor: 'primary.light' }
          },
          '& .bad-transaction': { bgcolor: `${red[100]} !important` },
          '& .MuiButtonBase': { bgcolor: 'primary.main' },
          '& .MuiDataGrid-sortIcon': { color: 'primary.contrastText' },
          // '& .MuiDataGrid-footerContainer': { borderTop: 1, borderColor: 'info.dark' },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
          }
        }
      }
    },
    MuiAccordionSummary: { defaultProps: { sx: { bgcolor: 'secondary.dark', color: 'secondary.contrastText' } } },
    MuiSwitch: { defaultProps: { color: 'secondary' } },
    MuiGrid: { defaultProps: { spacing: 2 } },
    MuiDatePicker: { defaultProps: { sx: { width: '100%', height: 40 }, slotProps: { textField: { size: 'small' } } } }
  }
})

function CustomNoRowsOverlay() {
  return (
    <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center' height='100%'>
      <Inbox sx={{ fontSize: 64, color: 'info.dark' }} />
      <Typography fontWeight='bold'>No Rows</Typography>
    </Box>
  )
}